import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { getServicesByCategory } from '@/lib/content';

interface CategorySidebarProps {
  activeId?: string;
  onNavigate?: () => void;
}

export default function CategorySidebar({ activeId, onNavigate }: CategorySidebarProps) {
  return (
    <aside className="w-full lg:w-full">
      <div className="rounded-lg bg-background-50 border border-background-200 p-4">
        <h2 className="flex items-center gap-2 text-sm font-semibold text-foreground-900 mb-3 px-1">
          <i className="ri-apps-2-line text-primary-600"></i>
          服务分类
        </h2>
        <ul className="space-y-1">
          {categories.map((cat) => {
            const active = cat.id === activeId;
            return (
              <li key={cat.id}>
                <Link
                  to={`/category/${cat.id}`}
                  onClick={onNavigate}
                  className={`flex items-center gap-2.5 px-3 py-2.5 rounded-md text-sm transition-colors cursor-pointer ${
                    active
                      ? 'bg-primary-50 text-primary-700 font-semibold'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  <i className={`${cat.icon} text-lg`}></i>
                  <span className="flex-1 truncate">{cat.name}</span>
                  <span className={`text-xs ${active ? 'text-primary-500' : 'text-foreground-400'}`}>
                    {getServicesByCategory(cat.id).length}
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
        <Link
          to="/categories"
          onClick={onNavigate}
          className="mt-3 flex items-center justify-center gap-1.5 px-3 py-2.5 rounded-md text-sm border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
        >
          <i className="ri-layout-grid-line"></i>
          查看全部分类
        </Link>
      </div>
    </aside>
  );
}